import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RegistrationPage from './pages/RegistrationPage';
import AdminPage from './pages/AdminPage';
import ConfirmationPage from './pages/ConfirmationPage';
import './App.css';
import './styles/sweetalert2-custom.css';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RegistrationPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
      </Routes>
    </Router>
  );
}

export default App;
